import { Checkbox, Header } from "semantic-ui-react"

const HeidiToggle = ({ updateProfile, data }) => {

    if (!data?.claims?.doc) return null;

    const checked = data.xtra?.heidi_integration_override;

    const onToggle = (_, { checked }) => updateProfile('xtra', { heidi_integration_override: checked });

    return (
        <div className="mt-12">
            <hr />
            <Header as="h3">Manage Scribe Access</Header>
            <div className="flex flex-row items-center">
                <span className="mr-4 pb-1">Enable HeidiAI</span>
                <Checkbox
                    toggle
                    checked={checked}
                    onChange={onToggle}
                />
            </div>
        </div>
    )
};

export default HeidiToggle;
